module.exports = __webpack_public_path__ + "img/form-builder.027e1630.svg";